import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICardModel } from '@src/app/interface/users';
import { TripsService } from '@src/app/services/user-managment/trips/trips.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-book-history',
  templateUrl: './book-history.component.html',
  styleUrls: ['./book-history.component.css']
})
export class BookHistoryComponent implements OnInit {

 subscription = new Subscription();

  allTrips: ICardModel[] = [];
  trips: ICardModel[] = [];
  pageSize = 5;


  constructor(public tripService : TripsService, public translate: TranslateService) { }

  ngOnInit(): void {
    if(this.tripService.allTrips.upcomingFlights.length){
      this.allTrips = this.tripService.getFlightDetails(this.tripService.allTrips.upcomingFlights);
      this.trips = this.allTrips.slice(0, this.pageSize);
    }

    this.subscription.add(
      this.tripService.notify.subscribe({
        next: (data) => {
          if(data){

          }else{
            this.allTrips = this.tripService.getFlightDetails(this.tripService.allTrips.upcomingFlights);
            this.trips = this.allTrips.slice(0, this.pageSize);
          }
          
        }
    }))
  }


  onPaginate(currentPage: any) {
    const startIndex = (currentPage - 1) * this.pageSize;
    const lastIndex = startIndex + this.pageSize - 1;

    this.trips = this.allTrips.slice(startIndex, lastIndex);
  }

  get lang() {
    return this.translate.currentLang;
  }

  get isLoading() {
    return this.tripService.isLoading;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
